import React from "react";
import { TStaticDrawFunction } from "../../../Components/Canvas";
import { MeasurementChartPainter } from "./MeasurementChartPainter";
import MeasurementChart from "./MeasurementChart";
import { IControl } from "../types";
import useControlMeasurements from "../../../hooks/useControlMeasurements";
import { useTranslation } from "react-i18next";

interface IClimatePressureChartProps {
  control: IControl;
  width: number;
  height: number;
}

const ClimatePressureChart = (props: IClimatePressureChartProps) => {
  const { control, width, height } = props;
  const { value, valuesList } = useControlMeasurements(control, ["pressure"]);
  const { t } = useTranslation();

  if (!valuesList) {
    return null;
  }

  const draw: TStaticDrawFunction = (ctx) => {
    const chart = new MeasurementChartPainter(width, height);
    chart.drawLines(ctx, valuesList, ["#000000"], "");
  };

  return (
    <MeasurementChart
      title={t("Pressure") + ` ${value}mBar`}
      draw={draw}
      width={width}
      height={height}
    />
  );
};

export default ClimatePressureChart;
